/** The manifest's airport slugs alone, for code that ships to the browser without the
 *  listing's facts. */
export const LISTED_AIRPORT_SHUTTLE_SLUGS: readonly string[] = [
    '/airport-shuttles/boston-logan--bos',
    '/airport-shuttles/charlotte-douglas--clt',
    '/airport-shuttles/cancun--cun',
    '/airport-shuttles/denver-airport--den',
    '/airport-shuttles/newark-liberty--ewr',
    '/airport-shuttles/new-york--jfk',
    '/airport-shuttles/harry-reid--las',
    '/airport-shuttles/orlando--mco',
    '/airport-shuttles/miami--mia',
    '/airport-shuttles/new-orleans-airport--msy',
    '/airport-shuttles/philadelphia--phl',
    '/airport-shuttles/phoenix--phx',
    '/airport-shuttles/san-diego--san',
    '/airport-shuttles/seattle-tacoma--sea',
    '/airport-shuttles/san-francisco--sfo',
    '/airport-shuttles/tampa--tpa',
]
